/**
 * Sales Completeness API Service
 *
 * Etat de completude des ventes : tickets de caisse en attente de remontee vers Bill,
 * resultats des controles nocturnes.
 */

import { apiClient } from '@/api/client';
import type {
  PosReceiptGapItem,
  PosReceiptGapsQueryParams,
  PosReceiptGapsResponse,
  SalesCompletenessQueryParams,
  SalesCompletenessResponse,
} from '@bstock/shared';

export async function getSalesCompleteness(params: SalesCompletenessQueryParams): Promise<SalesCompletenessResponse> {
  const response = await apiClient.get<{ success: boolean; data: SalesCompletenessResponse }>(
    '/sales/completeness',
    { params }
  );
  return response.data.data;
}

export async function getReceiptGaps(params: PosReceiptGapsQueryParams): Promise<PosReceiptGapItem[]> {
  const response = await apiClient.get<{ success: boolean; data: PosReceiptGapsResponse }>(
    '/sales/completeness/gaps',
    { params }
  );
  return response.data.data.data;
}

export const salesCompletenessService = {
  getSalesCompleteness,
  getReceiptGaps,
};
